module.exports = __webpack_public_path__ + "static/media/historicoMobile.5a124c4d.jpg";